import Icon from '../components/Icon.vue'

Icon.register({
  'sort-alpha-up': {
    width: 448,
    height: 512,
    paths: [
      {
        d: 'M4.7 116.7L84.7 36.7C90.9 30.4 101.1 30.4 107.3 36.7L187.3 116.7C197.4 126.8 190.2 144 176 144H128V464C128 472.8 120.8 480 112 480H80C71.2 480 64 472.8 64 464V144H16C1.8 144-5.3 126.7 4.7 116.7zM306.4 215.3A12-12 0 0 0 294.8 224H259.1C250.9 224 245.1 215.9 247.8 208.1L304.9 40.1A12-12 0 0 0 316.2 32H355.8C360.9 32 365.5 35.3 367.1 40.1L424.2 208.1C426.9 215.9 421.1 224 412.9 224H377.1A12-12 0 0 0 365.6 215.4L357.3 187.1H314.5L306.4 215.3zM329.2 136.6H342.6L336 113.7 329.2 136.6zM341.8 423.9L409.3 328.2A12-12 0 0 1 411.4 321.3V300C411.4 293.4 406.1 288 399.4 288H274.5C267.9 288 262.5 293.4 262.5 300V328.9C262.5 335.6 267.9 340.9 274.5 340.9H331C330.3 341.9 329.5 343 328.7 344.1L261.5 439.3A12-12 0 0 1 259.3 446.2V468C259.3 474.6 264.7 480 271.3 480H400.7C407.3 480 412.7 474.6 412.7 468V439.1C412.7 432.4 407.3 427.1 400.7 427.1H339.5C340.3 426.1 341 425 341.8 423.9z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/sort-alpha-up.js
// module id = 4TlB
// module chunks = 144